import { GAME_WIDTH } from '../constants';

export function isInHole(
  ballX: number,
  ballY: number,
  ballSpeed: number,
  holeX: number,
  holeSurfaceY: number,
  holeWidth: number,
  holeDepth: number,
  captureSpeed: number
): boolean {
  if (ballSpeed >= captureSpeed) return false;

  const halfW = holeWidth / 2;
  const leftX = holeX - halfW;
  const rightX = holeX + halfW;
  const bottomY = holeSurfaceY + holeDepth;

  // Check Y bounds — ball must be near the hole floor, not just anywhere in the rectangle
  const floorMargin = holeDepth * 0.5;
  if (ballY < bottomY - floorMargin || ballY > bottomY) return false;

  // Check X bounds with horizontal wrapping
  // Direct check
  if (ballX >= leftX && ballX <= rightX) return true;

  // Wrapped check
  const wrappedX1 = ballX + GAME_WIDTH;
  if (wrappedX1 >= leftX && wrappedX1 <= rightX) return true;

  const wrappedX2 = ballX - GAME_WIDTH;
  if (wrappedX2 >= leftX && wrappedX2 <= rightX) return true;

  return false;
}
